export default {
  metaTitle: '管理代金券模版',
  pageTitle: '管理代金券模版',
  region: '国别',
  BD: 'BD',
  columns1: 'ID',
  columns2: '名称',
  columns3: '所有者类型',
  columns4: '是否有限制',
  columns5: '使用门槛(要求)',
  columns6: '面额上限',
  columns7: '每人可领',
  columns8: '限制类型',
  columns9: '限定到',
  columns10: '状态',
  ownerType1: '平台',
  ownerType2: '店铺',
  status1: '启用',
  status2: '禁用'
}
